module.exports = {"TXTCLI_Play":{"id":"TXTCLI_Play","defaultMessage":"Jouer","flags":["TRACK"],"track":"Play"}}